import { t } from '@/plugins/i18n'

export const shippingProductColumnsEn:any = [
  {
    label: t('图片'),
    prop: 'productMainImg',
    align: 'center',
    slotName: 'productMainImg'
  },
  {
    label: t('sku/平台商品信息'),
    prop: 'productSkuInfo',
    width: 250,
    align: 'center',
    slotName: 'productSkuInfo'
  },
  {
    label: t('代采商品良品数'),
    prop: 'useable',
    align: 'center'
  },
  {
    label: t('一口价良品数'),
    prop: 'allIncludeUseable',
    align: 'center'
  },
  {
    label: t('客户商品sku'),
    prop: 'customerProductMsku',
    align: 'center'
  }
]
export const shippingProductColumns:any = [
  ...shippingProductColumnsEn,
  {
    label: t('海外仓sku'),
    prop: 'overseaProductSku',
    align: 'center'
  }
]

export const replenishmentProductColumns:any = [
  {
    label: t('图片'),
    prop: 'productMainImg',
    align: 'center',
    slotName: 'productMainImg'
  },
  {
    label: t('sku/平台商品信息'),
    prop: 'productSkuInfo',
    width: 250,
    align: 'center',
    slotName: 'productSkuInfo'
  },
  {
    label: t('代采商品良品数'),
    prop: 'useable',
    align: 'center'
  },
  {
    label: t('一口价良品数'),
    prop: 'allIncludeUseable',
    align: 'center'
  },
  {
    label: t('Amazon sku/AMAZON商品名称'),
    prop: 'amazonMsku',
    align: 'center',
    slotName: 'amazonMsku'
  },
  {
    label: t('海外仓（fnsku）/asin'),
    prop: 'amazonFnsku',
    align: 'center',
    slotName: 'amazonFnsku'
  }
]

export const productTableConfig = {
  showSelection: true
}

export const getAreaTxt = (row: { area: any }, provinces: any) => {
  const t: any = (provinces || []).find((e: any) => e.intAreaId === row.area)
  return t?.label
}

export const getCityTxt = (row: { area: any; city: any }, provinces: any) => {
  const t: any = (provinces || []).find((e: any) => e.intAreaId === row.area)
  if (t) {
    const v = t.children.find((e: { intAreaId: any }) => e.intAreaId === row.city)
    return v?.label
  } else {
    return ''
  }
}

export const getInternationalAreaTxt = (row: { area: any }, provinces: any, key:string) => {
  const t: any = (provinces || []).find((e: any) => e.intAreaId === row.area)
  return t?.[key] || ''
}

export const getInternationalCityTxt = (row: { area: any; city: any }, provinces: any, key:string) => {
  const t: any = (provinces || []).find((e: any) => e.intAreaId === row.area)
  if (t) {
    const v = t.children?.find((e: { intAreaId: any }) => e.intAreaId === row.city)
    return v?.[key] || ''
  } else {
    return ''
  }
}
